import React, { useEffect, useState } from 'react'
import InputWithSuggest from '../../components/InputWithSuggest';
import { MultiSelect, SButton, SelectBox, TextInputWithLabel } from '../../components';
import { useSelector } from 'react-redux';
// import { addRegistration } from '../../redux/registration/action';
import { useLocation, useNavigate } from 'react-router-dom';
import FlatPickr from 'react-flatpickr';
import ShowAlert from '../../components/ShowAlert';
import { Ceklis } from '../../assets';
import { API_BASE_URL } from '../../config';

function Form({title}) {
    const user = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const location = useLocation();

    const [input, setInput] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingLoad, setLoadingLoad] = useState(false);
    
    const [optGender,setOptGender] = useState([
        {
            value: 'Male',
            label: 'Male'
        },
        {
            value: 'Women',
            label: 'Women'
        }
    ]);
    const [selectGender, setSelectGender] = useState(null);

    const [optMarital,setOptMarital] = useState([]);
    const [selectMarital, setSelectMarital] = useState(null);

    const [optTherapis,setTherapis] = useState([]);
    const [selectTherapis, setSelectTherapis] = useState(null);

    const [optTreatment,setTreatment] = useState([]);
    const [selectTreatment, setSelectTreatment] = useState(null);

    const [optRoom,setRoom] = useState([]);
    const [selectRoom, setSelectRoom] = useState(null);
    
    const [isSaving, setIsSaving] = useState(false);

    const [errors, setErrors] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [showNotif, setShowNotif] = useState(false);

    const [hasSelectedSuggestion, setHasSelectedSuggestion] = useState(false);
    const [notifType, setNotifType] = useState('success');
    const [notifMessage, setNotifMessage] = useState('Form has been successfully submitted!');
    
    
    const [form, setForm] = useState({
        id: 0,
        patient: '',
        full_name: '',
        no_medical_record: '',
        identity_number:'',
        phone_number: '',
        email:'',
        place_of_birth: '',
        date_of_birth:'',
        marital_status:'',
        religion:'',
        gender: '',
        member_type:'',
        address:'',
        no_regist: '',
        no_appointment:'',
        treatment:'',
        kd_employee:'',
        doctor_id: '',
        room_id: '',
        notes: '',
        created_by: '',
        klinik_id: '',
        status: '',
        status_regist: ''
    });

    const validateForm = () => {
        const newErrors = {};
        if (!form.full_name) newErrors.full_name = "Name is required";
        if (!form.place_of_birth) newErrors.place_of_birth = "Place Birth is required";
        if (!form.date_of_birth) newErrors.date_of_birth = "Date birth is required";
        if (!form.address) newErrors.address = "Address is required";
        if (!form.religion) newErrors.religion = "Religion is required";
        if (!form.email) {
            newErrors.email = "Email is required";
        }else if(!/\S+@\S+\.\S+/.test(form.email)){
            newErrors.email = "Invalid email address.";
        }
        if (!form.phone_number) {
            newErrors.phone_number = "Telephone is required.";
        } else if (!/^\d+$/.test(form.phone_number)) {
            newErrors.phone_number = "Telephone must contain only numbers.";
        }
        if (!form.identity_number) {
            newErrors.identity_number = "Identity is required.";
        } else if (!/^\d+$/.test(form.identity_number)) {
            newErrors.identity_number = "Identity must contain only numbers.";
        }
        return newErrors;
    };


    useEffect(() => {
        if (!input.trim()) {
            setSuggestions([]); // Kosongkan saran jika input kosong
            return;
        }
        const fetchSuggestions = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/patient_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );
                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data registrasi!');
                    return;
                }
                const response = await res.json();  
                const filteredSuggestions = response.data.filter(
                    (p) =>
                        p.full_name.toLowerCase().includes(input.toLowerCase()) ||
                        p.no_medical_record.includes(input)
                );
                setSuggestions(filteredSuggestions);                 
            } catch (error) {
                console.error("Error fetching suggestions:", error);
            } finally {
                setLoading(false);
            }
        };

        const debounceFetch = setTimeout(fetchSuggestions, 300);
        return () => clearTimeout(debounceFetch);
    },[input,user.user.klinik_id])

    useEffect(() => {
        setLoadingLoad(true);

        const fetchTherapis = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/employee_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );
                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const therapists = await res.json();                   

                setTherapis(
                    Array.isArray(therapists.data)
                        ? therapists.data.filter(item => item.role === 1).map(item => ({
                            value: item.id || item.value,
                            label: item.full_name || item.label,
                        }))
                        : []
                );
            } catch (error) {
                console.error("Error fetching doctor:", error);
            } finally {
                setLoadingLoad(false);
            }
        };

        const fetchTreatment = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/master_treatment_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );
                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const treatment = await res.json();                   

                setTreatment(
                    Array.isArray(treatment.data)
                        ? treatment.data.map(item => ({
                            value: item.id || item.value,
                            label: item.treatment_name || item.label,
                        }))
                        : []
                );
            } catch (error) {
                console.error("Error fetching Treatment:", error);
            } finally {
                setLoadingLoad(false);
            }
        };

        const fetchRooms = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/room_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );
                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data registrasi!');
                    return;
                }
                const rooms = await res.json();
            
                setRoom(
                    Array.isArray(rooms.data)
                        ? rooms.data.map(item => ({
                            value: item.id || item.value,
                            label: item.name_room || item.label,
                        }))
                        : []
                );
            } catch (error) {
                console.error("Error fetching room:", error);
            } finally {
                setLoadingLoad(false);
            }
        }

        fetchTherapis();
        fetchTreatment();
        fetchRooms();

        setOptMarital([
            {
                value: 'belum_menikah',
                label: 'Belum Menikah'
            },
            {
                value: 'menikah',
                label: 'Menikah'
            }
        ]);
    
        setOptGender([
            {
                value: 'Male',
                label: 'Male'
            },
            {
                value: 'Female',
                label: 'Female'
            }
        ]);
    },[user.user.klinik_id])

    // Event handler untuk memilih saran
    const handleSuggestionClick = (suggestion) => {
        const genderObj = optGender.find(g => g.value === (suggestion.gender === 'Male' ? 'Male' : 'Female'));
        const maritalObj = optMarital.find(g => g.value === (suggestion.marital_status === 'Menikah' ? 'menikah' : 'belum_menikah' ));

        setInput(`${suggestion.full_name} (${suggestion.no_medical_record})`); 
        setForm({...form,
            id: suggestion.id,
            full_name: suggestion.full_name,
            email: suggestion.email,
            no_medical_record: suggestion.no_medical_record,
            identity_number: suggestion.identity_number,
            phone_number: suggestion.phone_number,
            place_of_birth: suggestion.place_of_birth,
            date_of_birth: suggestion.date_of_birth,
            address: suggestion.address,
            religion: suggestion.religion,
            gender: genderObj,
            marital_status: maritalObj
        })
        setSelectGender(genderObj);
        setSelectMarital(maritalObj);

        setHasSelectedSuggestion(true);
        setSuggestions([]);
    };

    const handleChangeGender = (e) => {
        setSelectGender(e);
        // Transformasi data untuk hanya menyimpan properti `value`
        const transformedGender = { value: e.value, label: e.label };
        setForm({...form,gender: transformedGender})
    };

    const handleChangeMarital = (e) => {
        setSelectMarital(e);
        // Transformasi data untuk hanya menyimpan properti `value`
        const transformedMarital = { value: e.value, label: e.label };
        setForm({...form,marital_status: transformedMarital})
    };

    const handleChangeTherapis = (e) => {
        setSelectTherapis(e);
        // Transformasi data untuk hanya menyimpan properti `value`
        const transformedTherapis = e.map(item => ({ value: item.value, label: item.label }));
        setForm({...form,doctor_id: transformedTherapis})
    };

    const handleChangeTreatment = (e) => {
        setSelectTreatment(e);
        // Transformasi data untuk hanya menyimpan properti `value`
        const transformedTreatment = e.map(item => ({ value: item.value, label: item.label }));
        setForm({...form,treatment: transformedTreatment})
    };

    const handleChangeRoom = (e) => {
        setSelectRoom(e);
        // Transformasi data untuk hanya menyimpan properti `value`
        const transformedRoom = { value: e.value, label: e.label };
        setForm({...form,room_id: transformedRoom})
    };

    const handleSubmit = async () => {
        const newErrors = validateForm();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        
        setIsSaving(true);
        setLoading(true);
        setLoadingLoad(true);

        let noMedicalRecord = form?.no_medical_record || '';
        
        // console.log(newRegistration);
        try {
            const token = localStorage.getItem('access_token');
            const ids = form.id ? form.id : 0;
            const checkPatient = await fetch(
                `${API_BASE_URL}/auth/patient/id/${ids}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    }
                }
            );
            let patientExists = false;
            let patientData = null;
            if (checkPatient.ok) {
                const res = await checkPatient.json();
                patientExists = Array.isArray(res.data) && res.data.length > 0;
                if (patientExists) {
                    patientData = res.data[0];
                    noMedicalRecord = patientData.no_medical_record;
                }
            }

            if (!patientExists) {
                const patientPayload = {
                    full_name: form?.full_name,
                    // no_medical_record: form?.no_medical_record,
                    identity_number: form?.identity_number,
                    phone_number: form?.phone_number,
                    email: form?.email,
                    place_of_birth: form?.place_of_birth,
                    date_of_birth: form?.date_of_birth,
                    marital_status: form?.marital_status?.value || 'belum_menikah',
                    gender: form?.gender?.value || 'Male',
                    religion: form?.religion,
                    member_type: form?.member_type || '',
                    address: form?.address,
                    klinik_id: user.user.klinik_id,
                    status: 'Y',
                    created_by: user.user.id
                };

                const createPatient = await fetch(
                    `${API_BASE_URL}/auth/patient/create`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        },
                        body: JSON.stringify(patientPayload)
                    }
                );
                if (!createPatient.ok) {
                    const err = await createPatient.json().catch(() => ({}));
                    setLoading(false);
                    setLoadingLoad(false);
                    setNotifType('danger');
                    setNotifMessage(err.message || 'Gagal membuat data registrasi!');
                    setShowNotif(true);
                    setIsSaving(false);
                    return;
                }
                const patientRes = await createPatient.json();
                noMedicalRecord = patientRes.data?.no_medical_record || '';
            }

            const newRegistration = {
                full_name: form?.full_name,
                no_medical_record: noMedicalRecord,
                no_appointment: '',
                treatment: form?.treatment[0].value,
                kd_employee: '',
                doctor: form?.doctor_id[0].value,
                room_id: form?.room_id.value,
                notes: form?.notes,
                created_by: user.user.id,
                klinik_id: user.user.klinik_id,
                status: 'Receipt',
                created_at: new Date().toISOString().split('T')[0],
            };

            const createRegistration = await fetch(
                `${API_BASE_URL}/auth/registration/create`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token && { Authorization: `Bearer ${token}` }),
                    },
                    body: JSON.stringify(newRegistration)
                }
            );
            if (!createRegistration.ok) {
                const err = await createRegistration.json().catch(() => ({}));
                setLoading(false);
                setLoadingLoad(false);
                setNotifType('danger');
                setNotifMessage(err.message || 'Gagal membuat data registrasi!');
                setShowNotif(true);
                setIsSaving(false);
                return;
            }

            setShowNotif(true);

            setForm({
                id: 0,
                patient: '',
                full_name: '',
                no_medical_record: '',
                identity_number:'',
                phone_number: '',
                email:'',
                place_of_birth: '',
                date_of_birth:'',
                marital_status:'',
                religion:'',
                gender: '',
                member_type:'',
                address:'',
                no_regist: '',
                no_appointment:'',
                treatment:'',
                kd_employee:'',
                doctor_id: '',
                room_id: '',
                notes: '',
                created_by: '',
                klinik_id: '',
                status: '',
                status_regist: ''
            });

            setErrors({});
            setSelectTreatment(null);
            setSelectGender(null);
            setSelectMarital(null);
            setSelectRoom(null);
            setSelectTherapis(null);
        } catch (error) {
            setLoading(false);
            setLoadingLoad(false);
            setNotifType('danger');
            setNotifMessage('Terjadi kesalahan koneksi!');
            setShowNotif(true);
            setIsSaving(false);
        } finally {
            setLoading(false);
            setLoadingLoad(false);
            setIsSaving(false);
        }
    }
    // Fungsi untuk menangani penutupan modal notifikasi
    const handleCloseConfirm = () => {
        setShowNotif(false);

        // Navigasi setelah notifikasi ditutup
        const basePath = location.pathname.split('/')[1];
        navigate(`/${basePath}`);
    };

    //DELETE PROSES
    const handleCancel  = () => {
        setShowModal(true); 
    }

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleConfirmCancel = () => {
        setShowModal(false);

        const basePath = location.pathname.split('/')[1];
        navigate(`/${basePath}`);
    };

    // Hilangkan error saat input di-highlight
    const handleFocus = (field) => {
        setErrors((prev) => ({ ...prev, [field]: undefined }));
    };

      // Fungsi untuk mengonversi waktu UTC ke WIB (UTC+7)
    const convertToIndonesiaTime = (date) => {
        const localDate = new Date(date)
        localDate.setHours(localDate.getHours() + 7) // Sesuaikan ke WIB (+7)
        return localDate.toISOString().slice(0, 16).replace('T', ' ')
    }
    
    const formatDateYMD = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    return (
        <>
        <div className='tab-content'>
            <div className='tab-pane fade show active'>
                <div className='d-flex flex-column'>
                    <div className='mb-10 card card-flush py-4'>
                        <div className='card-header'>
                            <div className='card-title'>
                                <h2>{title}</h2>
                            </div>
                        </div>

                        <div className='card-body pt-0'>
                            <div className='d-flex flex-column flex-md-row gap-5'>
                                <div className='flex-row-fluid'>
                                    <InputWithSuggest
                                        label={'Search Patient'}
                                        type={'text'}
                                        name={'patient'}
                                        placeholder={'Search Patient...'}
                                        value={input}
                                        onChange={(e) => {
                                            setInput(e.target.value);
                                            setHasSelectedSuggestion(false);
                                        }}
                                        loading={loading}
                                        suggestions={suggestions}
                                        map={
                                            suggestions.length > 0 ? (
                                                suggestions.map((s, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => handleSuggestionClick(s)}
                                                        style={{
                                                            padding: "10px",
                                                            cursor: "pointer",
                                                            borderBottom: "1px solid #eee",
                                                        }}
                                                    >
                                                        {s.no_medical_record},{s.full_name},{formatDateYMD(s.date_of_birth)}
                                                    </li>
                                                ))
                                            ) : (
                                                input && !loading && !hasSelectedSuggestion && (
                                                    <li style={{ padding: "10px", color: "#888" }}>
                                                        Not found
                                                    </li>
                                                )
                                            )
                                            
                                        }
                                    />
                                </div>
                                <div className='flex-row-fluid'>
                                    <TextInputWithLabel
                                        type={'text'}
                                        label={'No. Medical Record'}
                                        name={'no_medical_record'}
                                        labelClass={'required form-label'}
                                        placeholder={'Nomor Medical Record'}
                                        value={form?.no_medical_record}
                                        onChange={(e) => setForm({...form,no_medical_record: e.target.value})}
                                        onFocus={() => handleFocus('no_medical_record')}
                                        style={{
                                            borderColor: errors.no_medical_record ? 'red' : '',
                                        }}
                                    />
                                    <label style={{color:'red'}}>{errors.no_medical_record}</label>
                                </div>
                            </div>

                            <div className='d-flex flex-column flex-md-row gap-5'>
                                <div className='flex-row-fluid'>
                                    <TextInputWithLabel
                                        type={'text'}
                                        label={'Full Name'}
                                        name={'full_name'}
                                        labelClass={'required form-label'}
                                        value={form?.full_name}
                                        onChange={(e) => setForm({...form,full_name: e.target.value})}
                                        onFocus={() => handleFocus('full_name')}
                                        style={{
                                            borderColor: errors.full_name ? 'red' : '',
                                        }}
                                    />
                                    <label style={{color:'red'}}>{errors.full_name}</label>
                                </div>
                                <div className='flex-row-fluid'>
                                    <TextInputWithLabel
                                        type={'text'}
                                        label={'Identity Number'}
                                        name={'identity_number'}
                                        labelClass={'required form-label'}
                                        value={form?.identity_number}
                                        onChange={(e) => setForm({...form,identity_number: e.target.value})}
                                        onFocus={() => handleFocus('identity_number')}
                                        style={{
                                            borderColor: errors.identity_number ? 'red' : '',
                                        }}
                                    />
                                    <label style={{color:'red'}}>{errors.identity_number}</label>
                                </div>
                            </div>

                            <div className='d-flex flex-column flex-md-row gap-5'>
                                <div className='flex-row-fluid'>
                                    <TextInputWithLabel
                                        type={'text'}
                                        label={'No Telephone'}
                                        name={'phone_number'}
                                        labelClass={'required form-label'}
                                        placeholder={'Input your number..'}
                                        value={form?.phone_number}
                                        onChange={(e) => setForm({...form,phone_number: e.target.value})}
                                        onFocus={() => handleFocus('telephone')}
                                        style={{
                                            borderColor: errors.phone_number ? 'red' : '',
                                        }}
                                    />
                                    <label style={{color:'red'}}>{errors.phone_number}</label>
                                </div>
                                <div className='flex-row-fluid'>
                                    <TextInputWithLabel
                                        type={'email'}
                                        label={'Email'}
                                        name={'email'}
                                        labelClass={'required form-label'}
                                        placeholder={'Input your email..'}
                                        value={form?.email}
                                        onChange={(e) => setForm({...form,email: e.target.value})}
                                        onFocus={() => handleFocus('email')}
                                        style={{
                                            borderColor: errors.email ? 'red' : '',
                                        }}
                                    />
                                    <label style={{color:'red'}}>{errors.email}</label>
                                </div>
                            </div>

                            <div className='d-flex flex-column flex-md-row gap-5'>
                                <div className='flex-row-fluid'>
                                    <TextInputWithLabel
                                        type={'text'}
                                        label={'Place of Birth'}
                                        name={'place_of_birth'}
                                        labelClass={'required form-label'}
                                        placeholder={'Input your number..'}
                                        value={form?.place_of_birth}
                                        onChange={(e) => setForm({...form,place_of_birth: e.target.value})}
                                        onFocus={() => handleFocus('place_of_birth')}
                                        style={{
                                            borderColor: errors.place_of_birth ? 'red' : '',
                                        }}
                                    />
                                    <label style={{color:'red'}}>{errors.place_of_birth}</label>
                                </div>
                                <div className='flex-row-fluid'>
                                    <label className='required form-label'>Date of Birth</label>
                                    <FlatPickr
                                        className={`form-control ${errors.date_of_birth ? 'is-invalid' : ''}`}
                                        placeholder='Input your date'
                                        options={{
                                            enableTime: true, 
                                            dateFormat: 'Y-m-d H:i', 
                                            time_24hr: true, 
                                        }}
                                        value={form?.date_of_birth}
                                        onChange={(e) => setForm({ 
                                            ...form, 
                                            date_of_birth: convertToIndonesiaTime(e[0])
                                        })}
                                    />
                                    
                                    <label style={{color:'red'}}>{errors.date_of_birth}</label>
                                </div>
                            </div>

                            <div className='d-flex flex-column flex-md-row gap-5'>
                                <div className='flex-row-fluid'>
                                    <TextInputWithLabel
                                        type={'text'}
                                        label={'Address'}
                                        name={'address'}
                                        labelClass={'required form-label'}
                                        placeholder={'Input Address'}
                                        value={form?.address}
                                        onChange={(e) => setForm({...form,address: e.target.value})}
                                        onFocus={() => handleFocus('address')}
                                        style={{
                                            borderColor: errors.address ? 'red' : '',
                                        }}
                                    />
                                    <label style={{color:'red'}}>{errors.address}</label>
                                </div>
                                <div className='flex-row-fluid'>
                                    <TextInputWithLabel
                                        type={'text'}
                                        label={'Religion'}
                                        name={'religion'}
                                        labelClass={'required form-label'}
                                        placeholder={'Input Religion'}
                                        value={form?.religion}
                                        onChange={(e) => setForm({...form,religion: e.target.value})}
                                        onFocus={() => handleFocus('religion')}
                                        style={{
                                            borderColor: errors.religion ? 'red' : '',
                                        }}
                                    />
                                    <label style={{color:'red'}}>{errors.religion}</label>
                                </div>
                            </div>

                            <div className='mb-10 d-flex flex-column flex-md-row gap-5'>
                                <div className='flex-row-fluid'>
                                    <SelectBox
                                        classLabel={'form-label'}
                                        label={'Gender'}
                                        name={'gender'}
                                        value={selectGender || null}
                                        handleChange={handleChangeGender}
                                        options={optGender}
                                    />
                                </div>
                                <div className='flex-row-fluid'>
                                    <SelectBox
                                        classLabel={'form-label'}
                                        label={'Marital Status'}
                                        name={'marital_status'}
                                        value={selectMarital || null}
                                        handleChange={handleChangeMarital}
                                        options={optMarital}
                                    />
                                </div>
                            </div>

                            <div className='mb-10 fv-row fv-plugins-icon-container'>
                                <MultiSelect
                                    classLabel={'form-label'}
                                    label={'Select a Treatment'}
                                    name={'treatment'}
                                    value={selectTreatment}
                                    handleChange={handleChangeTreatment}
                                    options={optTreatment}
                                />
                            </div>

                            <div className='mb-10 fv-row fv-plugins-icon-container'>
                                <MultiSelect
                                    classLabel={'form-label'}
                                    label={'Select a Doctor'}
                                    name={'doctor_id'}
                                    value={selectTherapis}
                                    handleChange={handleChangeTherapis}
                                    options={optTherapis}
                                />
                            </div>

                            <div className='mb-10'>
                                <label className='form-label'>Notes</label>
                                <textarea
                                    id="notes"
                                    name='notes'
                                    rows="6"
                                    value={form?.notes}
                                    onChange={(e) => setForm({...form, notes: e.target.value})}
                                    placeholder="Write your notes or description here..."
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        fontSize: "14px",
                                        border: "1px solid #ccc",
                                        borderRadius: "5px",
                                        resize: "vertical",
                                    }}
                                />
                            </div>

                            <div className='mb-10 fv-row fv-plugins-icon-container'>
                                <SelectBox
                                    classLabel={'form-label'}
                                    label={'Room'}
                                    name={'room_id'}
                                    value={selectRoom || null}
                                    handleChange={handleChangeRoom}
                                    options={optRoom}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        <SButton
                            className={ 'btn btn-secondary me-5'}
                            variant={'secondary'}
                            action={handleCancel}
                        >
                            Cancel
                        </SButton>
                        <SButton
                            className={ isSaving ? 'btn btn-secondary' :'btn btn-primary'}
                            children={
                                isSaving ? 
                                (
                                    <>
                                        Please Wait...<span className="spinner-border spinner-border-sm me-2"></span>
                                    </>
                                )
                                : 'Save Changes'
                            }
                            variant={isSaving ? 'secondary' : 'primary'}
                            action={handleSubmit}
                            disabled={isSaving ? true : false}
                        >
                            {isSaving ? (
                                <>
                                    Please Wait...<span className="spinner-border spinner-border-sm me-2"></span>
                                </>
                            ) : 'Save Changes'}
                        </SButton>
                    </div>

                    {showModal && (
                        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Are you sure?</h5>
                                        <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className='swal2-icon swal2-warning swal2-icon-show d-flex'>
                                            <div className="swal2-icon-content">!</div>
                                        </div>
                                        <div className="swal2-html-container d-block" id="swal2-html-container">
                                            Are you sure you would like to cancel?
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <SButton
                                            className={ 'btn btn-danger'}
                                            variant={'danger'}
                                            action={handleConfirmCancel}
                                        >
                                            {isSaving ? (
                                                <>
                                                Please Wait...<span className="spinner-border spinner-border-sm me-2"></span>
                                                </>
                                            ) : 'Yes, Cancel It!'}
                                        </SButton>
                                        
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={handleCloseModal}
                                        >
                                            No, Return
                                        </button>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    { showNotif && (
                            // <ShowAlert 
                            // title={notifType === 'success' ? 'Ok, got it!' : 'Oops!'}
                            // message={notifMessage}
                            // pic={notifType === 'success' ? Ceklis : undefined}
                            // show={showNotif} 
                            // setShow={setShowNotif}
                            // onClose={handleCloseConfirm}
                            // swal={notifType === 'success' ? 'swal2-success' : 'swal2-danger'}
                            // />
                            <ShowAlert 
                                title={notifType === 'success' ? 'Ok, got it!' : 'Oops!'}
                                message={notifMessage}
                                svg={notifType === 'success' ? 'svg-icon-success' : (notifType === 'danger' ? 'svg-icon-danger' : 'svg-icon-warning')}
                                show={showNotif} 
                                setShow={setShowNotif}
                                onClose={handleCloseConfirm}
                                swal={notifType === 'success' ? 'swal2-success' : (notifType === 'danger' ? 'swal2-error' : 'swal2-warning')}
                            />   
                    )}
                    
                </div>
            </div>
        </div>
        {loadingLoad && (
            <div
                style={{
                position: 'fixed',
                zIndex: 2000,
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(255,255,255,0.6)',
                backdropFilter: 'blur(2px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
                }}
            >
                <div className="spinner-border text-primary" role="status" style={{ width: 60, height: 60 }}></div>
            </div>
        )}
        </>
    )
}

export default Form